<template>
    <main-dialog
        v-model="isVisible"
        :title="$t('convertHtmlToPdoc')"
        @hidden="handleClose"
        @ok="handleConvert"
        :ok-title="$t('convert')"
        :cancel-title="$t('cancel')"
    >
        <b-form @submit.prevent="handleConvert">
            <b-form-group
                :label="$t('documentPath')"
                :description="$t('documentPathHint')"
            >
                <b-form-input
                    v-model="documentPath"
                    :placeholder="$t('enterDocumentPath')"
                    required
                />
            </b-form-group>

            <b-form-group
                :label="$t('variant')"
                :description="$t('variantHint')"
            >
                <b-form-input
                    v-model="variant"
                    :placeholder="$t('enterVariant')"
                    required
                />
            </b-form-group>
        </b-form>
    </main-dialog>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        file: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            documentPath: '',
            variant: 'default'
        };
    },

    computed: {
        isVisible: {
            get() {
                return this.show;
            },
            set(value) {
                if (!value) {
                    this.$emit('close');
                }
            }
        }
    },

    watch: {
        show(newVal) {
            if (newVal) {
                this.initializeForm();
            }
        }
    },

    methods: {
        initializeForm() {
            // Set default path based on file name (without extension)
            const nameWithoutExt = this.file.name.replace(/\.(html|htm)$/i, '');
            this.documentPath = nameWithoutExt;
            this.variant = 'default';
        },

        handleConvert(e) {
            if (e) {
                e.preventDefault();
            }

            // Validate inputs
            if (!this.documentPath || !this.documentPath.trim()) {
                this.$bvToast.toast(this.$t('pleaseEnterDocumentPath'), {
                    title: this.$t('error'),
                    variant: 'danger'
                });
                return;
            }

            if (!this.variant || !this.variant.trim()) {
                this.$bvToast.toast(this.$t('pleaseEnterVariant'), {
                    title: this.$t('error'),
                    variant: 'danger'
                });
                return;
            }

            const options = {
                path: this.documentPath.trim(),
                variant: this.variant.trim()
            };

            this.$emit('convert', options);
            this.isVisible = false;
        },

        handleClose() {
            this.documentPath = '';
            this.variant = 'default';
            this.$emit('close');
        }
    }
};
</script>
